import { Paper } from '@mui/material';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { NotificationSearchResultItem } from './NotificationSearchResultItem';

interface NotificationSearchResultsProps {
  teamAbbrv: string;
  results: VideoItem[];
  onMoreInfo: (video: VideoItem) => void;
  onCreateDeeplink: (video: VideoItem) => void;
}

export function NotificationSearchResults({
  teamAbbrv,
  results,
  onMoreInfo,
  onCreateDeeplink,
}: NotificationSearchResultsProps) {
  if (results.length === 0) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      {results.map((item) => (
        <NotificationSearchResultItem
          key={item.id}
          teamAbbrv={teamAbbrv}
          item={item}
          onMoreInfo={onMoreInfo}
          onCreateDeeplink={onCreateDeeplink}
        />
      ))}
    </Paper>
  );
}
